<div class="fc-start-referral" *ngIf="referral$ | async as referral">
    <div class="fc-start-referral-frame">
        <div class="fc-start-referral-frame-body">
            <div class="fc-start-referral-frame-body-header">
                {{ 'SIGNUP.REFERRAL.HEADER' | translate }}
            </div>
            <div class="fc-start-referral-frame-body-description">
                <div>{{ 'SIGNUP.REFERRAL.DESCRIPTION_LINE1' | translate: { organization: referral.brand.name } }}</div>
                <div>{{ 'SIGNUP.REFERRAL.DESCRIPTION_LINE2' | translate }}</div>
            </div>

            <div class="fc-start-referral-frame-body-action-signup">
                <button
                    fcp-filled-button
                    data-e2e-hook="signup-verified-email-resend-button"
                    (click)="goToSignupForm(referral)"
                >
                    {{ 'SIGNUP.REFERRAL.START_BUTTON.LABEL' | translate }} <i class="fal fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>
